import moment from "moment";
var converter = require("number-to-words");

export default {
  methods: {
    $moduleAccess(data) {
      const access = this.$store.state.module.some((item) => {
        if (item.code === data) {
          return true;
        }
      });

      if (!access) {
        return false;
      }

      return true;
    },
    $infoBar(data) {
      this.$store.dispatch("dispatchInfobar", {
        text: data.text,
        type: data.type,
      });
      this.$store.dispatch("dispatchInfobarStatus", true);
    },
    $clearInfoBar() {
      this.$store.dispatch("dispatchInfobar", {
        text: "",
        type: "",
      });
      this.$store.dispatch("dispatchInfobarStatus", false);
    },
    async $changePage(data) {
      await this.$store.dispatch("dispatchModuleAccess", data.access_level);
      this.$router.push({
        path: data.page_data.link,
      });
    },
    $amountInPeso(data) {
      if (data === undefined || data === "") {
        return "";
      }
      return parseFloat(data).toLocaleString("fil-PH", {
        style: "currency",
        currency: "PHP",
      });
    },
    $amountToWord(data) {
      var str = data.toFixed(2);
      var numarray = str.split(".");

      let cent = "";

      if (numarray.length > 1)
        cent = " AND " + converter.toWords(parseInt(numarray[1])) + " CENTS";

      return converter.toWords(parseInt(data)) + " PESOS" + cent;
    },
    $dateFormat: function(data, format) {
      var now = null;
      if (data) {
        now = moment(data).format(format);
      } else {
        now = moment().format(format);
      }

      return now;
    },
    $firstLetter(data) {
      if (data === undefined || data === "") {
        return;
      }
      return data.charAt(0).toUpperCase();
    },
    $capitalizeFirstLetter(data) {
      if (data === undefined || data === "") {
        return;
      }
      return data[0].toUpperCase() + data.slice(1);
    },
    $capitalizeName(name) {
      if (!name) return;
      if (name == "ltfrb report") name = "LTFRB report";

      if (name == "eod summary report") name = "EOD summary report";

      return name.replace(/\b(\w)/g, (s) => s.toUpperCase());
    },
    $isEmpty(data) {
      if (data === undefined || data === "") {
        return;
      }
      return Object.keys(data).length === 0;
    },
    $isValidate(data) {
      if (data === null || data === undefined || data === "") {
        return false;
      } else {
        return true;
      }
    },
    $roundOffByHundreds(number) {
      if (number) {
        if (number.toString().includes(".")) {
          const decimal_count = number.toString().split(".")[1].length;
          if (decimal_count > 3) {
            number = (Math.round(number * 1000) / 1000).toFixed(3);
          }
        }
      }
      return (Math.round(number * 100) / 100).toFixed(2);
    },
  },
};
